<template>
  <div class="hello">
    <h2 style="text-align: center">视一壁纸版权声明</h2>
    <p>&#12288;&#12288;视一壁纸根据用户指令提供作品上传、下载以及传播等，向来十分重视网络版权及其他知识产权以及用户权益的保护。视一壁纸依照《中华人民共和国侵权法》、《中华人民共和国著作权法》、《信息网络传播权保护条例》等法律法规及相关规章制度的规定，采取如下知识产权措施：</p>
    <br/>
    <p>&#12288;&#12288;1、视一壁纸向用户传达版权保护理念，提示用户不得上传和传播侵权作品。同时，视一壁纸对上传作品进行严格审查，向网络用户公示视一壁纸的基本审查标准，提示用户严格遵守法律法规及尊重他人合法权益。</p>
    <br/>
    <p>&#12288;&#12288;2、本网站所有作品皆来源于原作者的授权，收本网站著作权原则保护，本网站在用户上传作品会做审查，但其真实性、合法性、准确性等瑕疵不可归咎于视一壁纸，视一壁纸无法完全保证其作品来源的原创性等权利。</p>
    <br/>
    <p>&#12288;&#12288;3、视一壁纸对于有理由确信存在明显侵权、违法、违反公共利益等情形的作品时，有权不事先通知并随时删除该等侵权作品。</p>
    <br/>
    <p>&#12288;&#12288;4、视一壁纸尊重作品版权，支持权利人（包括版权人、肖像权人等）将侵权情况告知视一壁纸，共同合作净化网络空间，减少侵权行为的发生。视一壁纸将在接到符合要求的权利通知后，及时删除涉嫌侵权的作品和相关内容。</p>
    <br/>
    <p>&#12288;&#12288;5、视一壁纸动员网络用户对视一壁纸上的作品进行全面监督，视一壁纸会在第一时间对举报进行核实，及时清理侵权作品，并视情况对举报人进行奖励。</p>
    <br/>
    <p>&#12288;&#12288;6、网络用户下载视一壁纸的作品，应在与视一壁纸签订具体合同的作品的授权许可范围内使用。同时，作品下载使用者遵守著作权法及其他相关法律的规定，不得侵害本网站及权利人的合法权利。</p>
    <br/>
    <p>&#12288;&#12288;7、视一壁纸保留追究任何第三方侵权使用本网站作品的权利。如果您侵犯了本网站作品的著作权，您将被要求按著作权侵权惩罚性赔偿标准或最高达50万元人民币的法定赔偿标准承担赔偿责任。</p>
    <br/>
    <p style="font-weight: bold">&#12288;&#12288;您可以向视一壁纸所设立的专门接受版权投诉和侵权通知的邮箱发送通知书。</p>
    <br/>
    <p style="font-weight: bold">&#12288;&#12288;侵犯公民个人名誉权、肖像权、个人或单位的著作权、商标权等知识产权的情况请将投诉资料发至：<span style="color: red">shiyipic@foxmail.com</span></p>
    <br/>
    <p>&#12288;&#12288;申诉需知</p>
    <br/>
    <p>投诉方应当提供包含下列文件：</p>
    <br/>
    <p>&#12288;&#12288;1、权利人的姓名（名称）、联系方式、地址、身份证扫描件（自然人）、企业法人营业执照（单位）、法定代表人身份证明（单位）;</p>
    <br/>
    <p>&#12288;&#12288;2、求删除或者断开链接的侵权作品的准确名称和网络地址，以便视一壁纸能够发现并初步审核涉嫌侵权作品；</p>
    <br/>
    <p>&#12288;&#12288;3、成侵权的初步证明材料，包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明，以及对涉嫌侵权作品侵权事实的举证。</p>
    <br/>
    <p>&#12288;&#12288;4、通知书需由权利人或其合法授权人亲笔签名，若为单位则需加盖单位公章。</p>
    <br/>
    <p>&#12288;&#12288;5、权利人应对通知书的真实性负责。若通知书的内容不真实，权利人将承担由此造成的全部法律责任。</p>
    <br/>
    <p>&#12288;&#12288;一旦收到符合上述要求之通知，我们将在合理时间内删除涉嫌侵权的作品。如不符合上述条件，我们会请阁下提供相应信息，且暂不采取包括删除等相应措施。</p>
    <br/>
    <p>&#12288;&#12288;在视一壁纸上载作品的用户视为同意视一壁纸就前款情况所采用的相应措施。视一壁纸不因此而承担任何违约责任或其他任何法律责任。视一壁纸在收到上述通知后会发送电子邮件通知上载该等作品的用户。对于多次上载涉嫌侵权作品的用户，我们将取消其用户资格。</p>
    <br/>
    <p>&#12288;&#12288;在您发送邮件后，工作人员会尽快处理，由于涉及内容不同，所需周期也不同，请您耐心等待。</p>
    <br/>
  </div>
</template>

<script>
export default {
  name: 'Copyright',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
.hello {
  text-align: left;
  padding-left: 200px;
  width: 1000px;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Copyright.vue